import "./accordion/accordion.js";
import "./video_player/video_player.js";

import "./posts_loader/posts_loader.js";
import "./tab_content/tab_content.js";
import "./newsletter_signup/newsletter_signup.js";
import "./sliders/sliders.js";
import "./text_content/text_content.js";
import "./hero_video/hero_video.js";
import "./testimonial/testimonial.js";
import "./posts/cards/cards.js";
import "./current_developments_slider/current_developments_slider.js";
// import "./hover_boxes/hover_boxes.js";

import "./test_popup/test_popup.js";